module.exports = __webpack_public_path__ + "img/potion-medium.bd8fffb8.svg";